import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ExternalJobRedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const externalJobId = localStorage.getItem('ExternalJobId');
    const jobIdForNavigation = localStorage.getItem('jobIdForNavigation');

    const isExternalLoginRedirect = location.search.includes('source=google') || location.search.includes('source=linkedin');

    if (externalJobId) {
      if (jobIdForNavigation) {
        navigate(`/jobs/${jobIdForNavigation}`);
      } else {
        navigate('/jobs');
      }

      // Clean up only after navigation
      localStorage.removeItem('ExternalJobId');
      localStorage.removeItem('jobIdForNavigation');
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const isJobPage = location.pathname.includes('/jobs');
    const hasExternalJobId = localStorage.getItem('ExternalJobId');

    if (isJobPage && hasExternalJobId) {
      localStorage.removeItem('ExternalJobId');
      localStorage.removeItem('jobIdForNavigation');
      console.log('ExternalJobId cleaned up after direct navigation to /jobs');
    }
  }, [location.pathname]);

  return null;
};

export default ExternalJobRedirectHandler;
